<template>
  <v-container fluid>
    <v-card>
      <PageTitle
        text="Calendário"
        title-class="h5"
        :show-border-bottom="true"
      />
      <Calendar />
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/common/components/PageTitle'
import Calendar from "./components/Calendar";

export default {
  components:{
    Calendar,
    PageTitle
  },
}
</script>
